export const createCustomer = `
    mutation createCustomer($input: CreateCustomerInput!) {
        createCustomer(input:$input) {
            id
            name
            description
    }
}`;

// FNP-575: the single writer of Account.customerId. Re-assigning a Customer's
// owner = SET this account's customerId to the chosen Customer (idempotent SET,
// overwrites a stale/dangling value). The linkage event then flows through the
// seam → FNP-491 projection → derived ownerAccountId. admin-only (@aws_cognito
// admin group, per the FNP-575 backend change).
export const setAccountCustomerId = `
    mutation setAccountCustomerId($input: SetAccountCustomerIdInput!) {
        setAccountCustomerId(input:$input) {
            id
            customerId
            updated
        }
    }`;
